export interface UserFormState {
  name: string
  email?: string
  phone?: string
  role_ids: string[]
  status: 'active' | 'inactive'
  image_id?: string
  image_url_temp?: string
  password?: string
  permissions?: string[]
  /** Staff card scanned at the till's lock screen (POS.md §18.8). */
  barcode?: string
}

export const userFieldsConfig = () => {
  return {
    fields: {
      name: {
        rules: {
          required: 'Full name is required',
        },
      },
      email: {
        rules: {
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: 'Invalid email address',
          },
        },
      },
      image_id: {
        // rules: {
        //     required: 'Image is required',
        // }
      },
      role_ids: {
        rules: {
          required: 'At least one role is required',
          validate: (val: string[]) => (val && val.length > 0) || 'At least one role is required',
        },
      },
      password: {
        rules: {
          // Password only required on create
        },
      },
    },
  }
}

/** A new staff card code: `ST` + time + random, CODE128; the server refuses one already in use. */
export const newStaffCard = () => `ST${Date.now().toString(36).toUpperCase()}${Math.floor(Math.random() * 1296).toString(36).toUpperCase().padStart(2, '0')}`
